<div class="video-container">
    @if (videoUrl || thumbnail) {
        <div
            class="video-card"
            [class.video-card--video]="videoUrl"
            [class.video-card--playing]="isVideoPlaying()"
        >
            @if (videoUrl && !isVideoPlaying()) {
                <div
                    class="video-card__media"
                    role="button"
                    tabindex="0"
                    [attr.aria-label]="playLabel"
                    (click)="onVideoClick()"
                    (keydown.enter)="onVideoClick()"
                    (keydown.space)="onVideoClick()"
                >
                    @if (thumbnail) {
                        <img
                            class="video-card__media__img"
                            [ngSrc]="thumbnail"
                            height="200"
                            width="200"
                            alt="{{ altText || 'video thumbnail' }}"
                            [id]="'image-' + id"
                        />
                    } @else {
                        <div class="video-card__media__placeholder">
                            <img
                                class="video-card__media__placeholder__logo"
                                [ngSrc]="'/assets/logos/nw-logo-secondary-no-strapline-on-dark.png'"
                                height="55"
                                width="300"
                                alt="{{ altText || 'video thumbnail' }}"
                                [id]="'image-' + id"
                            />
                        </div>
                    }
                    <div class="video-card__media__play-overlay">
                        <nw-icon class="video-card__media__play-overlay__icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 56 56"
                            >
                                <circle
                                    cx="28"
                                    cy="28"
                                    r="28"
                                    fill="white"
                                    fill-opacity="0.85"
                                />
                                <path
                                    fill="currentColor"
                                    d="M22 18.5L38 28L22 37.5V18.5Z"
                                />
                            </svg>
                        </nw-icon>
                    </div>
                    @if (duration) {
                        <div class="video-card__media__duration">
                            {{ duration }}
                        </div>
                    }
                </div>
            } @else if (videoUrl) {
                <div class="video-card__media video-card__media--video">
                    <iframe
                        class="video-card__media__iframe"
                        [src]="playbackUrl() | sanitizeUrl"
                        title="Video player"
                        frameborder="0"
                        allow="
                            accelerometer;
                            autoplay;
                            clipboard-write;
                            encrypted-media;
                            gyroscope;
                            picture-in-picture;
                            web-share;
                        "
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                    ></iframe>
                </div>
            } @else {
                <div class="video-card__media">
                    <img
                        class="video-card__media__img"
                        [ngSrc]="thumbnail!"
                        height="200"
                        width="200"
                        [alt]="altText || ''"
                        [id]="'image-' + id"
                    />
                </div>
            }
        </div>
    }
</div>
